import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/pixelify-sans/500.css';
import '@fontsource/pixelify-sans/600.css';
import '@fontsource/nunito/500.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/800.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import './styles/tokens.css';
import './styles/shell.css';
import './styles/ui.css';
import './styles/apps.css';
import './styles/playground.css';
import './styles/nimu.css';
import { Desktop } from './os/Desktop';
import { startCoordinatorPolling } from './state/coordinator';
import { discoverWallets, startBalancePolling } from './state/wallet';
import { initServices } from './services/init';

discoverWallets();
startCoordinatorPolling();
startBalancePolling();
initServices();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Desktop />
  </StrictMode>,
);
